import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

function AuthProvider(props) {
    const [login, setLogin] = useState(() => {
        const saved = localStorage.getItem('isLoggedIn');
        return saved === 'true';
    });

    useEffect(() => {
        localStorage.setItem('isLoggedIn', login);
    }, [login]);

    const value = [login, setLogin];

    return <AuthContext.Provider value={value} {...props} />;
}

function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}

export { AuthProvider, useAuth };
